import React from "react";
import LocationCard from "./LocationCard";
import { LOCATION_THEMES } from 'variables/constants';

const Locations = ({ locations, selectedId, setSelectedId }) => {

    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
            {locations?.map((loc) => (
                <LocationCard
                    key={loc.id}
                    {...loc}
                    theme={LOCATION_THEMES[loc.country]}
                    selected={loc.id === selectedId}
                    onClick={() => setSelectedId(loc.id)}
                />
            ))}
        </div>
    )
};
export default Locations;

